import './App.css';
import React, {useState, useEffect} from "react";

// import Header from "./components/header.js";
import Directory from './components/directory.js';

function App() {

  // const [deptFilter, setDeptFilter] = useState(14);

  return (
    <div className="people-directory">
      <div class="fadein">
        {/* <Header departments={departments} /> */}
        {/* <Header deptChoice={deptFilter}/> */}
        {/* <Directory departments={departments} /> */}
        <Directory />
      </div>
    </div>
  );
}

export default App;
